import NarratorBio from './NarratorBio';

export { NarratorBio };
